import { Crown } from "lucide-react";
import { LEAD_RANK_LABELS, LEAD_RANK_FULL_LABELS, LEAD_RANK_COLORS } from "@/lib/constants";

// Senior-instructor rank chip (SLI / ACI / CI). Renders nothing for unranked coaches
// — the vast majority of the roster. Orthogonal to the existing tier chip; intentionally
// uses a prestige palette (cyan/indigo/gold) so it doesn't blur with tier1/2/3 colors.
//
// `size`: "xs" for dense lists (board, picker rows), "sm" for forms/header areas.
// `id` (optional): appended to data-testid so it's queryable per-coach.
export function LeadRankChip({ rank, size = "xs", id, className = "" }) {
  if (!rank || !LEAD_RANK_LABELS[rank]) return null;
  const palette = LEAD_RANK_COLORS[rank];
  const baseSize = size === "sm"
    ? "px-1.5 py-0.5 text-[0.65rem]"
    : "px-1 py-0 text-[0.6rem]";
  return (
    <span
      data-testid={id ? `lead-rank-chip-${id}` : "lead-rank-chip"}
      data-lead-rank={rank}
      title={LEAD_RANK_FULL_LABELS[rank]}
      className={`inline-flex items-center gap-1 border rounded-sm font-bold uppercase tracking-[0.18em] font-mono ${baseSize} ${palette} ${className}`}
    >
      <Crown className="h-2.5 w-2.5" /> {LEAD_RANK_LABELS[rank]}
    </span>
  );
}
